//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/gallery'
import 'devextreme/ui/load_indicator'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { i18n } from '../i18n/common.i18n'
import { CommonHelper, CorrelationType } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { TemplateHelper, ConfigHelper, IUserSession } from '../../../helpers'

//#region Asset Imports

import './gallery.scss'
import * as TEMPLATE from './gallery.tpl.html'

//#endregion

interface GalleryScope extends ng.IScope {
    schemas: any[]
    isDxGallery: boolean
    schemaGalleryOptions: DevExpress.ui.dxGalleryOptions
    slickOptions: any
    isLoaded: boolean
    id: number
    disableRefresh: boolean
    referenceType: number
    correlationType: number
    eventNameForSchemaChanged?: string

    lastSlide: number
    selectedSlide: number

    isFullScreen: boolean
    resizeButtonOptions: DevExpress.ui.dxButtonOptions
}

export class GalleryDirective implements ng.IDirective {
    constructor() { }

    restrict = 'E'
    scope = {
        schemas: '=',
        disableRefresh: '=',
        referenceType: '=?',
        correlationType: '=?',
        eventNameForSchemaChanged: '=?',
        schemaOwner: '='
    }
    template = TEMPLATE

    link = (scope: ng.IScope, element: JQuery) => {
        scope.$watchCollection("schemas", (value: any[]) => {
            scope['isLoaded'] = false
            setTimeout(() => {
                scope['isLoaded'] = true
            }, 0)
        })
    }

    controller = ['$scope', '$element', 'api', 'logger', 'localDictionary', '$timeout', 'userSession', ($scope: GalleryScope, $element: JQuery, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, $timeout: ng.ITimeoutService, userSession: IUserSession) => {
        $scope.id = new Date().getTime()
        $scope.isDxGallery = window['config']['GALLERY_TYPE'] == 'dx-gallery'
        $scope.schemaGalleryOptions = {
            height: '100%',
            width: '100%',
            items: $scope.schemas
        }

        var resizeSchema = ($scope: GalleryScope) => {
            $scope.isLoaded = false
            $scope.isFullScreen = !$scope.isFullScreen
        }

        $scope.resizeButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.FULLSCREEN, userSession),
            hint: i18n('Common', 'Fullscreen'),
            onClick: e => {
                resizeSchema($scope)
            }
        }

        if (!$scope.eventNameForSchemaChanged) $scope.eventNameForSchemaChanged = ''

        $scope.lastSlide = 0
        $scope.$root.$broadcast(EventsNames.SCHEMA_CHANGED + $scope.eventNameForSchemaChanged, $scope.schemas[0])

        $scope.slickOptions = {
            autoplay: false,
            enabled: true,
            dots: true,
            method: {},
            event: {
                afterChange: (e, slick) => {
                    if ($scope.lastSlide != slick.currentSlide) {
                        $scope.$root.$broadcast(EventsNames.SCHEMA_CHANGED + $scope.eventNameForSchemaChanged, $scope.schemas[slick.currentSlide])
                        $scope.lastSlide = slick.currentSlide
                    }
                    $scope.selectedSlide = slick.currentSlide
                    $scope.$root.$broadcast(EventsNames.DASHBOARD_SLIDER_SLICKED, $scope.schemas[slick.currentSlide])
                }
            },
            nextArrow: '<div class="slick-next"><span class="fa fa-angle-right"></span><span class="sr-only">Next</span></div>',
            prevArrow: '<div class="slick-prev"><span class="fa fa-angle-left"></span><span class="sr-only">Previous</span></div>'
        }

        $scope.$watch(() => {
            return angular.element('.schemas' + $scope.id).width()
        }, (val) => {
            slickUpdate()
        })

        var slickUpdate = () => {
            if (!$scope.disableRefresh) {
                $scope.slickOptions.initialSlide = $scope.selectedSlide
                $timeout(() => {
                    $scope.isLoaded = true
                })
            }
        }

        var getSchemas = (referenceType: number, id: number) => {
            var controller: string = ''
            switch (referenceType) {
                case CommonHelper.IdLocation:
                    controller = 'location'
                    break
                case CommonHelper.IdMeter:
                    controller = 'meter'
                    break
                case CommonHelper.IdDevice:
                    controller = 'device'
                    break
            }
            if (controller) {
                $scope.isLoaded = false
                api[controller]['getSchemas'](id).then(response => {
                    if (response) {
                        if (response.result.length) $scope.schemas = response.result
                        else $scope.schemas = [{ schema: null }]
                        $scope.$root.$broadcast('schemasLoaded', $scope.schemas)
                        $scope.isLoaded = true
                    }
                }).catch(reason => {

                })
            }
        }

        $scope.$on(EventsNames.DASHBOART_GRID_ROW_SELECTED, (event: ng.IAngularEvent, ...args: any[]) => {
            var referenceValues: any[] = args[0] || []
            var referenceType: number = args[1]
            var correlationType: number = $scope.correlationType

            if (referenceValues.length > 0) {
                if (correlationType == CorrelationType.None) return
                if (correlationType == CorrelationType.Local) {

                    var value = referenceValues[0]
                    var index = null
                    $scope.schemas.forEach((val, i) => {
                        if (value == val.idObject && referenceType == val.referenceType)
                            index = i
                    })
                    if (index) {
                        $scope.slickOptions.method.slickGoTo(index)
                    }
                }
                if (correlationType == CorrelationType.Server) {
                    var value = referenceValues[0]
                    if (referenceType && value)
                        getSchemas(referenceType, value)
                }
            }
            if (referenceValues.length == 0 && correlationType == CorrelationType.Server) {
                $scope.schemas = [{ schema: null }]
                $scope.$root.$broadcast('schemasLoaded', $scope.schemas)
            }
        })

        $scope.$on(EventsNames.DASHBOARD_MAP_MARKER_CLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            var selectedMarker = args[0]
            var referenceType: number = args[1]
            var correlationType: number = $scope.correlationType

            if (selectedMarker) {
                if (correlationType == CorrelationType.None) return
                if (correlationType == CorrelationType.Local) {
                    var value = selectedMarker
                    var index = null
                    $scope.schemas.forEach((val, i) => {
                        if (value.id == val.idObject && referenceType == val.referenceType)
                            index = i
                    })
                    if (index) {
                        $scope.slickOptions.method.slickGoTo(index)
                    }
                }
                if (correlationType == CorrelationType.Server) {
                    if (referenceType && selectedMarker.id)
                        getSchemas(referenceType, selectedMarker.id)
                }
            }
        })
    }]
}